module.exports = __webpack_public_path__ + "img/PingYang.7297ba4d.jpg";